import { render, staticRenderFns } from "./screen-resume.vue?vue&type=template&id=b086fdc6&scoped=true&"
import script from "./screen-resume.vue?vue&type=script&lang=js&"
export * from "./screen-resume.vue?vue&type=script&lang=js&"
import style0 from "./screen-resume.vue?vue&type=style&index=0&id=b086fdc6&scoped=true&lang=css&"
import style1 from "./screen-resume.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b086fdc6",
  null
  
)

export default component.exports